'use strict';

global.artworkId = null;
global.loadHomepage = false;

global.flipValueDefault = 1;
global.isCabbageValueDefault = false;
global.rotationValueDefault = 0;

global.media = $('#audio').get(0);

global.thumb = {};
global.updateGlobalThumbElement = function () {
  global.thumb = $(document).find('.preview').find('.preview__image');
};
global.updateGlobalThumbElement();
global.updateThumb = function (id, counter) {
  $.get('/generate-artwork-image', {
    width: 217,
    height: 304,
    artworkId: id
  }, function(output) {
    if (output.error) {
      console.log('Ops! Qualcosa è andato storto!');
      if (typeof counter == "undefined") {
        counter = 0;
      }
      // prova a generarla un paio di volte
      if (counter < 2) {
        updateThumb(id, counter + 1);
      }
    } else {
      global.thumb.attr('src', output.src);
    }
    // console.log(output);
  });
};

$(document).ready(function() {

  /**
   * Setta i cookie se non sono presenti
   */
  if (!cookies.getCookie('cookie_bar_enabled')) {
    $('[data-js="cookie-bar"]').show();
  }

  $('[data-js="cookie-accept"]').click(function() {
    cookies.setCookie('cookie_bar_enabled', 'true', 364);
  });

  /**
   * Inizializza il plugin Fullpage
   * se presenti più pagine costruisce la struttura delle sezioni
   */
  if ($('.pages').length) {

    $('.pages').fullpage({
      animateAnchor: false,
      sectionSelector: '.pages__page',
      scrollOverflow: true,
      scrollOverflowOptions: {
        click: false,
        preventDefaultException: { tagName: /.*/ }
      },
      afterLoad: function(anchorLink, index) {

        /**
         * Imposto la variabile loadHomepage a TRUE
         * e controllo successivamente se questa variabile è settata a FALSE
         * in modo da impedire all'utente di ricaricare la pagina e trovarsi
         * in sezioni interne senza essere passati dalla home
         */
        if(index == 1) {
          global.loadHomepage = true;
        }

        if(global.loadHomepage == false) {
          $.fn.fullpage.silentMoveTo(1);
        }
      },
      afterRender: function() {
        // $('#video')[0].play();
      }
    });

    $.fn.fullpage.setAllowScrolling(false);
    $.fn.fullpage.setKeyboardScrolling(false);

    $(document).on('click', '[data-js="move-down"]', function (e) {
      if($( this ).context.id == 'inizio'){
        console.log('Inizio');
        dataLayer.push({
          event: 'click',
          context_submitted:'inizio'
        })
      }
      
      if($( this ).context.id == 'salva'){
        console.log('Salva');
        dataLayer.push({
          event: 'click',
          context_submitted:'salva'
        })
      }

      if($( this ).context.id == 'titolo'){
        console.log('Titolo');
        dataLayer.push({
          event: 'click',
          context_submitted:'titolo'
        })
      }
      
      $.fn.fullpage.moveSectionDown();
    });

    $(document).on('click', '[data-js="move-up"]', function () {
      $.fn.fullpage.moveSectionUp();
    });

    $(document).on('click', '[data-js="move-to"]', function (event) {
      var $section = event.target.dataset.move;

      $.fn.fullpage.moveTo($section);
    });
  }

  /**
   * Inizializza il plugin selectize
   * per la formattazione della select nel form invio
   * solamente su dispositivi desktop
   *
   * Inizializza l'audio solo per i dispositivi desktop
   */
  if ($(window).width() >= 1025) {
    $('.selectize').selectize();
    global.audio.init();
  }

  /**
   * Gestisce lo switch ON/OFF dell'audio
   */
  $('[data-js="audio-control"]').click(function () {
      if($(this).is(':checked')) {
          global.audio.fadeIn(global.media);
          $('[data-js="audio-diagram"]').removeClass('audio__diagram_status_disabled');
          $('[data-js="audio-diagram"]').addClass('audio__diagram_status_enabled');
      } else {
          global.audio.fadeOut(global.media);
          $('[data-js="audio-diagram"]').removeClass('audio__diagram_status_enabled');
          $('[data-js="audio-diagram"]').addClass('audio__diagram_status_disabled');
      }
  });
});

/**
 * Variabili globali
 */
global.choose = require('./pages/choose.js');
//global.idea = require('./pages/idea.js');
global.steal = require('./pages/steal.js');
global.success = require('./pages/success.js');
global.editor = require('./editor/editor.js');
global.canvas = require('./editor/canvas.js');
global.modifiers = require('./editor/modifiers.js');
global.delivery = require('./pages/delivery.js');
global.cookies = require('./cookies.js');
global.audio = require('./audio.js');
global.delivery.global = global;

/**
 * Viene gestito il refresh delle gallery presenti nelle modal
 */
$('[data-js="modal-steal"]').on('open.zf.reveal', function(event) {
  $('.gallery-artwork__carousel_theme_steal').trigger('refresh.owl.carousel');
});

/**
 * Detect IOS safari
 * @returns {Array|{index: number, input: string}}
 */
function isMobileSafari() {
  var ua = window.navigator.userAgent;
  return /(iPad|iPhone|iPod).*WebKit/.test(ua) && !/(CriOS|OPiOS)/.test(ua);
}

if (isMobileSafari()) {
  $('body').addClass('safari-ios');
}
